import React from "react";
import { ChevronContainer, ShowMoreButtonContainer } from "./styled";
import { ReactComponent as Chevron } from "../../assets/icon/chevron-down.svg";

export function ShowMoreButton({ isExpanded = false, onClick }) {
  return (
    <ShowMoreButtonContainer onClick={onClick}>
      {isExpanded ? "Скрыть" : "Показать ещё"}
      <ChevronContainer isExpanded={isExpanded}>
        <Chevron />
      </ChevronContainer>
    </ShowMoreButtonContainer>
  );
}
